import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from 'react';
import ContextMenu from '../../../ContextMenu/ContextMenu';
import TrashDocumentsTableOptionsMenu from './TrashDocumentsTableOptionsMenu';
const TrashDocumentsTableContextMenu = forwardRef(({ document }, ref) => {
    const Menu = useCallback((props) => (_jsx(TrashDocumentsTableOptionsMenu, { ...props, document: document })), [document]);
    return _jsx(ContextMenu, { ref: ref, Menu: Menu });
});
export default TrashDocumentsTableContextMenu;
